import { useEffect, useState } from 'react';
import { Activity } from 'lucide-react';
import { api } from '@/services/api';
import clsx from 'clsx';

interface Worker {
  worker_id: string;
  host: string;
  last_seen: string;
  status: string;
  last_seen_seconds_ago: number | null;
  capabilities: string | null;
}

export function WorkerHealth() {
  const [workers, setWorkers] = useState<Worker[] | null>(null);

  useEffect(() => {
    let alive = true;
    const tick = () =>
      api
        .get<{ workers: Worker[] }>('/workers')
        .then((r) => alive && setWorkers(r.workers))
        .catch(() => {});
    tick();
    const h = setInterval(tick, 30_000);
    return () => {
      alive = false;
      clearInterval(h);
    };
  }, []);

  if (workers == null) return null;
  const online = workers.filter((w) => (w.last_seen_seconds_ago ?? 99999) < 120).length;
  const total = workers.length;

  return (
    <div className="card flex items-center justify-between px-4 py-2 text-sm">
      <div className="flex items-center gap-2 text-gray-700 dark:text-gray-200">
        <Activity className="h-4 w-4 text-primary-600" />
        Workers
        <span className="font-semibold tabular-nums">
          {online}/{total}
        </span>
        online
      </div>
      <ul className="flex flex-wrap items-center gap-2 text-xs">
        {workers.map((w) => {
          const live = (w.last_seen_seconds_ago ?? 99999) < 120;
          return (
            <li
              key={w.worker_id}
              className={clsx(
                'rounded-full px-2 py-0.5',
                live ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-700',
              )}
              title={`${w.host} · last seen ${w.last_seen_seconds_ago ?? '?'}s ago`}
            >
              {w.worker_id.replace(/^peterchen\.laptop\./, 'L')}
              {live ? ' ●' : ' ○'}
            </li>
          );
        })}
        {workers.length === 0 && (
          <li className="text-gray-500">No workers registered yet</li>
        )}
      </ul>
    </div>
  );
}
